const URIS = {
  SIGN_IN_WITH_USERNAME_AND_PASSWORD: '/auth/sign-in',
  LOGOUT: '/auth/sign-out',
  UPDATE_HOSPITAL_PROFILE: '/hospital/profile/update',
  VIEW_HOSPITAL_DETAILS: '/hospital/profile/view',
  LIST_HOSPITAL_BOOKINGS: '/hospital/bookings',
};

export default URIS;
